export enum AuthTenant {
  Primary = 'primary',
  Secondary = 'secondary'
}
